import { ReactNode } from "react";

export const ListGroupNameDescription = (props: { name: string; description: ReactNode }) => {
    const { name, description } = props;

    return (
        <div className="flex-grow-1 d-inline-block text-truncate">
            <div className="fw-bolder">{name}</div>

            {description && <small className="text-body-secondary">{description}</small>}
        </div>
    );
};
